import { omit } from 'lodash';
import qs from 'qs';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { ResultsCount } from '../../components/results-count';
import { IOrder, Status } from '../../graphql/types';
import { White2 } from '../../styles/colours';
import { Overlay } from './overlay/overlay';
import { ItemDetailsOverlayContent } from './overlay/overlay-content';
import { orderDetailsRoute } from './route';
import { OrderDetailsSearchControls } from './search-controls';
import { OrderDetailsTable } from './table/table';

const StyledOrderDetailsSection = styled.section`
  padding: 4.5rem 7.5rem 4.5rem 7.5rem;
  background-color: ${White2};
`;

const StyledSearch = styled.div`
  padding: 1rem 0rem 0rem 0rem;
`;

const ItemDetailsSlideOut: FC<{ order: IOrder; itemId?: string }> = ({
  order,
  itemId,
}) => {
  const history = useHistory();
  const onClickOutside = () => {
    const originalParams = omit(
      qs.parse(history.location.search, { ignoreQueryPrefix: true }),
      'itemId',
      'uid'
    );

    return history.push(
      orderDetailsRoute(order.soldTo.id, originalParams as any)
    );
  };

  const items = order.items;
  if (items) {
    const item = items.find(orderItem => orderItem.index === itemId);
    if (item) {
      return (
        <Overlay
          onClickOutside={onClickOutside}
          open={true}
          data-value="selected-item"
        >
          <ItemDetailsOverlayContent order={order} item={item} />
        </Overlay>
      );
    }
  }

  return (
    <Overlay
      onClickOutside={onClickOutside}
      open={false}
      data-value="no-selected-item"
    />
  );
};

export const OrderDetailsBody: FC<{
  order: IOrder;
  itemId?: string;
  statuses: Status[];
}> = ({ order, itemId, statuses }) => {
  const orderItemsFilteredByStatus =
    statuses.length > 0
      ? order.items?.filter(item => statuses.includes(item.status))
      : order.items;

  return (
    <StyledOrderDetailsSection>
      <StyledSearch>
        <ResultsCount
          label="Item"
          count={orderItemsFilteredByStatus?.length || 0}
        />
        <OrderDetailsSearchControls
          statuses={statuses}
          items={order.items || []}
          soldToId={order.soldTo.id}
        />
      </StyledSearch>
      <OrderDetailsTable
        order={{ ...order, items: orderItemsFilteredByStatus }}
        itemId={itemId}
      />
      <ItemDetailsSlideOut
        order={{ ...order, items: orderItemsFilteredByStatus }}
        itemId={itemId}
      />
    </StyledOrderDetailsSection>
  );
};
